import { render, staticRenderFns } from "./getLabelView.vue?vue&type=template&id=7da54d2e&scoped=true"
import script from "./getLabelView.vue?vue&type=script&lang=js"
export * from "./getLabelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da54d2e",
  null
  
)

export default component.exports